import { lazy } from 'react';

/** dmn-jsもBPMN同様に大きいので、判定タブを開いたときだけ読み込む。 */
export const DmnViewerLazy = lazy(async () => {
  const module = await import('./DmnViewer');
  return { default: module.DmnViewer };
});

export type { DmnViewerProps, DmnViewKind } from './DmnViewer';
